import { useQuery } from "react-query";
import { getSalesType } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveSalesType = () => {
  return useQuery("SalesType", getSalesType, {
    refetchOnWindowFocus: false,
  });
};
